import api from './api';

const state = {
	list: [],
	default: null,
};

const mutations = {
	setList(state, locales) {
		state.list = locales.locales;
		state.default = locales.default;
	},
};

const actions = {
	getLocales({ commit }) {
		return api
			.getLocales()
			.then((response) => {
				const locales = response.data;
				commit('setList', locales);
			})
			.catch((err) => {
				console.log(err);
			});
	},

	async getLocale({ state }, localeKey) {
		const response = await api.getLocale(localeKey);
		return response.data;
	},
};

export default {
	namespaced: true,
	state,
	actions,
	mutations,
};
